<div class="container my-5">
  <div class="card shadow">
    <div class="card-body p-5">

      <h1 class="text-center mb-4">
        User Data Deletion Instructions
      </h1>

      <p><strong>Last Updated:</strong> 2026-09-10</p>

      <hr />

      <h4>1. Introduction</h4>
      <p>
        At <strong>s1az.com</strong>, we respect your privacy and your right
        to control your personal information.
      </p>
      <p>
        This page explains how users can request the deletion of personal
        information associated with their s1az.com account and our services.
      </p>

      <h4 class="mt-4">2. How to Request Data Deletion</h4>
      <p>
        If you would like to request deletion of your personal data,
        please follow these steps:
      </p>

      <ol>
        <li>
          Send an email to
          <a href="mailto:info@s1az.com">info&#64;s1az.com</a>.
        </li>
        <li>
          Use <strong>"User Data Deletion Request"</strong> as the email subject.
        </li>
        <li>
          Provide the mobile number associated with your account.
        </li>
        <li>
          We may verify your mobile number or identity before processing
          the request to prevent unauthorized deletion requests.
        </li>
        <li>
          After successful verification, we will process the request and
          delete applicable personal information from our active systems.
        </li>
      </ol>

      <h4 class="mt-4">3. Data That May Be Deleted</h4>
      <p>
        Depending on your use of our services, the following information
        may be deleted:
      </p>

      <ul>
        <li>User profile and account information</li>
        <li>Mobile number and contact information</li>
        <li>WhatsApp-related identifiers stored by our system</li>
        <li>Customer activity associated with the account</li>
        <li>Shopping cart information</li>
        <li>Product interaction information</li>
        <li>Other personal information associated with the account</li>
      </ul>

      <h4 class="mt-4">4. Information We May Retain</h4>
      <p>
        Certain information may need to be retained when required for
        legal, regulatory, accounting, security, fraud-prevention, or
        legitimate business record-keeping purposes.
      </p>

      <p>
        This may include transaction records, orders, invoices, accounting
        records, security logs, and audit records where retention is
        required or permitted by applicable law.
      </p>

      <h4 class="mt-4">5. Meta and WhatsApp Data</h4>
      <p>
        s1az.com uses the <strong>WhatsApp Business Platform</strong>
        provided by Meta for supported business functionality, including
        customer verification, transactional communication, order
        notifications, and commerce-related integrations.
      </p>

      <p>
        If your deletion request concerns information received or processed
        through our Meta or WhatsApp integration, we will delete applicable
        information stored within s1az.com's systems in accordance with
        your request and applicable requirements.
      </p>

      <p>
        Deleting information from s1az.com does not automatically delete
        information independently stored or controlled by Meta.
      </p>

      <h4 class="mt-4">6. Facebook Login</h4>
      <p>
        s1az.com does not use Facebook Login as part of our customer
        ordering, mobile verification, or WhatsApp OTP process.
      </p>

      <h4 class="mt-4">7. Processing of Deletion Requests</h4>
      <p>
        After receiving a valid deletion request, we will verify the request
        and take reasonable steps to delete applicable personal information
        from our active systems.
      </p>

      <p>
        We may contact you if additional information is required to verify
        your identity or identify the relevant account.
      </p>

      <h4 class="mt-4">8. Contact Information</h4>
      <p>
        To request deletion of your data or ask questions regarding
        data deletion, please contact:
      </p>

      <p>
        <strong>s1az.com</strong><br />
        Address: 227, East Rampura, Dhaka, 1219, Bangladesh<br />
        Email:
        <a href="mailto:info@s1az.com">info&#64;s1az.com</a><br />
        Phone:
        <a href="tel:+8801706088146">+8801706088146</a>
      </p>

      <p>
        Please use <strong>"User Data Deletion Request"</strong>
        as the subject of your email.
      </p>

    </div>
  </div>
</div>
